import { configFilename } from "./configFilename.js";
import type { Config } from "./Config.js";

export async function resolveConfig(origin = ""): Promise<Config> {
  const configPath = `/${configFilename}`;
  const response = await fetch(origin + configPath);
  return response.json();
}
